import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class MiddleEditCommand extends Component {
  state = { canShowForm: false };
  
  render() {
    
    return (
        
<svg viewBox="0 0 500.947 500.947" style ={{ marginTop: "3px", marginBottom: "-3px"  }} className={"svg" + " " + this.props.className}>
<g>
	<g>
		<g>
			<polygon points="0,303.947 0,383.947 80,383.947 316.053,147.893 236.053,67.893 			"/>
			<path d="M377.707,56.053L327.893,6.24c-8.32-8.32-21.867-8.32-30.187,0l-39.04,39.04l80,80l39.04-39.04
				C386.027,77.92,386.027,64.373,377.707,56.053z"/>
		</g>
	</g>
</g></svg>
    );

    /*<svg className="svg">
          <rect x="5" y="9" width="16" height="1.5" rx="1" />
          <rect x="12" y="2" width="1.5" height="16" rx="1" />
        </svg>
        {this.state.canShowForm && detailForm}
        */
  }
}

export default MiddleEditCommand;
